module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "1. Comfort"
    }
  }, [_c('p', {
    staticClass: "h2-c"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253043184_Contents#rch1"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Comfort")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACH DAY, WE")]), _vm._v(" perform hundreds of actions. Each day, thousands of things happen to us. Some we don’t notice; others we consider insignificant. By tomorrow, almost everything that took place in this ordinary today will have been forgotten; a year from now, we will probably remember nothing of it at all. Forgetting lightens the burden of existence by liberating us from the past. It leaves us with a firm sense of who we are, though little in the way of particulars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this way, much of what shapes our lives escapes attention or memory. Although we remember some highlights, we know little of the details of how things went for us twenty or forty years ago. We may silently suppose that, in important ways, nothing has ever been very different from what it is today. Our knowledge of history should correct such hapless suppositions, but that knowledge, too, is limited to a few dates, signal events, and a sense of general tendencies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("History would help if it were the story of how people used to live. But the daily existence of ordinary people has attracted little of the attention of historians. The stress on great persons and momentous events has made it difficult for us to relate ourselves to the people who went before. We rarely ask and cannot answer the question of what our lives would have been like had we lived fifty or five hundred years ago. We know little of how we have lived and almost nothing about the life of earlier generations. Without comparisons, we can neither understand nor assess our current condition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps only ignorance of economics, which has ruined the Soviet Union and its affiliated republics, can match our innocence of historical reality. The present’s preoccupation with itself is well symbolized by the question a college student once asked me. In speaking of self-sacrifice in the service of a cause, I used the word "), _c('i', [_vm._v("kamikaze")]), _vm._v(". Was that the name, he inquired, of a new Japanese sedan? Young people appear to have trouble making the notion vivid for themselves that there were times in the history of the world when telephones and airplanes did not exist and when "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("bananas were not available year-round. Older folks don’t do much better, forgetting what they have seen with their own eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This ignorance and forgetfulness disguise the marvelous accomplishments of the modern world. To be sure, the comfort and plenty created by industrial civilization have not yet reached everyone on the planet. But a growing number of humans live longer, eat better, suffer less, and satisfy more of a broader range of desires than any previous generation. The great philosopher William James recognized this trend as early as 1907, when he wrote: “We approach the wishing-cap type of organization . . . in a few departments of life. We want water and we turn a faucet. We want a kodak-picture and we press a button. We want information and we telephone. We want to travel and we buy a ticket. In these and similar cases, we hardly need to do more than the wishing—the world is rationally organized to do the rest.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn1",
      "id": "ch01fn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To this list of comforts, James could now add high-speed travel by jet plane, instant communication with virtually every part of the world, the assured supply of wholesome and varied foods, and reliable medical care, among many others. Ordinary people in industrialized countries live much better today than kings did just a few hundred years ago. Kings never enjoyed the comforts of keeping their abode at the desired temperature throughout the year and of using a multitude of products to reduce pain, enhance taste, and eliminate many of the unpleasant side effects of organic life. They shared a world of stench with bedbugs and cockroaches. Their hairy parts provided a home for lice, and their teeth slowly rotted in their jaws. Many were in poor health much of the time; when they fell seriously ill, they were treated by charlatans who bled them or offered powdered pearls as lifesaving medicine. Control over the fate of others was their compensation for the inability to control their own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the twelfth century, complications attending childbirth often resulted in the mother’s death. Infant mortality was high; those who survived past puberty could expect to live to their thirties. Typhoid, pneumonia, and circulatory diseases of all sorts were rampant. Bad gums, ulcers, and even scurvy went largely untreated. Hordes of sick, crippled, maimed, blind, and mentally ill people roamed the grimy streets of the major cities. Disfiguring skin diseases made human bodies abhorrent to sight. Even among young people, good teeth and sweet breath were highly prized rarities."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn2",
      "id": "ch01fn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("In those days, travel was undertaken by foot or on horseback. A full day’s ride would carry the traveler about thirty-five miles over roads with large holes where the paving stones had been stolen. Some holes were large enough to break the leg and sometimes the neck of inattentive travelers. The journey from London to Paris required no less than seven days. It was unwise to attempt it alone: a single individual could readily fall prey to wild animals or brigands on the road.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most houses in the twelfth century consisted of a single room, which served as kitchen, living room, and bedroom. A waste pit near the fire at one end of the room “took care of sewage as well as kitchen refuse.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn3",
      "id": "ch01fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" Unlit city streets functioned as open sewers, carrying human waste to the river from which people took drinking water in pails back to their homes. As late as the seventeenth century, the Seine gave dysentery “to all except those who were natives of the region.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn4",
      "id": "ch01fn4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The history of dentistry affords an insight into how far the modern world has progressed. During the Middle Ages, toothaches and diseases of the gums received no reliable treatment. Dental surgery was so dangerous that Pope Gregory II “counseled prayer and endurance of pain rather than submission to the knife.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn5",
      "id": "ch01fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" As late as the sixteenth century, the extraction of a single tooth could lead to death: untrained surgeons frequently removed a portion of the jaw with the tooth, causing infection and general sepsis."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn6",
      "id": "ch01fn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To make teeth fall out so they would not have to be pulled, physicians recommended that dried cow’s dung or the fluid that results from boiling small green frogs be applied to the gums."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn7",
      "id": "ch01fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" Toothaches were treated by bleeding patients or by plunging hot needles into their gums and earlobes. Until the beginning of the nineteenth century, barbers and blacksmiths, who had little knowledge of anatomy or physiology, performed almost all tooth extractions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor teeth and inadequate dental care made human life miserable until less than a hundred years ago. Both George Washington and his wife experienced constant dental problems. He lost all but one of his teeth and found his dentures—some of them made of ivory, others of hippopotamus tusk and gold—thoroughly unsatisfactory."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch01rfn8",
      "id": "ch01fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" Good dental care, healthy diet, and the fluoridation of drinking water have so improved the teeth of young Americans that some schools of dentistry have closed and dentists are concerned about the future of their profession. This achievement constitutes an improvement in the quality of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("human life whose magnitude can be measured only by comparison with the pain endured by our ancestors throughout the ages.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Purists and Puritans object to the comforts we enjoy by charging that they render us soft and turn our attention from virtue and high culture to materialistic pursuits. The ills supposedly brought on by improvements in the conditions of life constitute a mighty list. They include self-indulgence, the loss of ideals, egoism, the breakdown of community values, and a vicious relativism that blinds us to the permanent differences between good and evil. Some look with admiration on groups such as the Amish that make do without modern conveniences in the name of a wholesome life. Others search for exemplars of a simple existence in the past and praise Thoreau or recommend the values of Native American tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are wayward, unfocused complaints. The modern world exacts a price for its comforts, but there is little doubt that the comforts are benefits. Nothing shows this more clearly than the fact that even those who most strongly condemn the pleasant life are reluctant to give it up. People who move to tight and clean utopian communities take their television sets with them. Evangelists inveighing against materialism fly in jet planes from city to city and stay in fine hotels. Those who want to simplify their lives rarely insist on drinking polluted water or playing host to parasites. The Amish themselves do not reject the blessings of technology—they travel in wheeled wagons, after all—they just limit these benefits to what existed at an earlier stage in the development of our skills.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Public choice is not irrelevant to determining the value of our comforts. Consistent preference of healthy food over garbage reveals something important about what is of value to human beings. The desire of people in developing countries for adequate housing, competent medical care, and private cars cannot be viewed as the expression of lamentable materialism. The unhesitating decision to stay in touch with loved ones far away suggests that such communication is not a dispensable nicety but an important part of a full human life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In any case, it is difficult to believe that toothaches and amoebic dysentery keep one’s mind on the ideal, while physical well-being leads to spiritual ruin. Does it conduce to self-indulgence not to die of childbirth at eighteen? Does it diminish our commitment to good music that everyone can hear it everywhere, rather than only the bishop and the prince in their castles? Does it reduce the quality of our conversation "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("that we can conduct it with interesting people on the other side of the globe? The hollowness of the attack on modern life in the name of higher values is best seen by observing the behavior of spiritual masters when they get near material goods. Hindu gurus come to mind, who flock to this country to teach discipline and self-abnegation and buy Cadillac limousines with the proceeds.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The success of governments devoted to providing public sanitation and security of person and property, along with the success of economies focused on the production of consumer goods, presents powerful evidence of the importance of comfort. The level of control we have achieved over disease, accident, and the requirements of decent life enable, for the first time in the history of the world, large numbers of people to enjoy a long and satisfying existence. It is rhetorical but not exaggerated to say that any life worse than this is inappropriate for humans.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn1"
    }
  }, [_vm._v("1")]), _vm._v(". William James, "), _c('i', [_vm._v("Pragmatism")]), _vm._v(" (Indianapolis: Hackett, 1981), 130.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Urban Tigner Holmes, Jr., "), _c('i', [_vm._v("Daily Living in the Twelfth Century")]), _vm._v(" (Madison: University of Wisconsin Press, 1952), 226–27.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn3"
    }
  }, [_vm._v("3")]), _vm._v(". Ibid., 97.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Ibid., 92.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Malvin E. Ring, "), _c('i', [_vm._v("Dentistry: An Illustrated History")]), _vm._v(" (New York: H. N. Abrams, 1985), 58.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Ibid., 129.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn7"
    }
  }, [_vm._v("7")]), _vm._v(". J. A. Taylor, "), _c('i', [_vm._v("History of Dentistry")]), _vm._v(" (Philadelphia: Lea & Febiger, 1922), 36.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch01rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch01fn8"
    }
  }, [_vm._v("8")]), _vm._v(". Ring, "), _c('i', [_vm._v("Dentistry: An Illustrated History")]), _vm._v(", 193.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3c6cf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253043184_Chapter_1.vue
// module id = 81
// module chunks = 0